import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Select from 'react-select';
import InlineSVG from 'svg-inline-react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import caret from './assets/ic_caret.svg';
import classes from './Embed.scss';
import PeoplePicker from '../../../components/PeoplePicker/PeoplePicker';
import { communicationTypes } from '../../../models/Activity';
import SimplWysiwyg from '../../SimplWysiwyg/SimplWysiwyg';

const _ = require('lodash');

export class Embed extends React.Component {
  editActivityInModal = () => {
    // this.props.setActivityForm(null, _.cloneDeep(this.props.activity));

    this.props.setState({ type: 'modal' });

    // this.props.resetActivity();
  };

  renderCommunicationDirection = () => {
    if (
      this.props.activity.communication_type === 'other' ||
      this.props.activity.communication_type === 'none'
    ) {
      return <div />;
    }

    return (
      <div className="col-xs-12 col-sm-8 off-sm-4">
        <RadioButtonGroup
          className="radiogroup radiogroup-horizontal radiogroup-horizontal-double"
          name="communication_direction"
          style={{ marginTop: 10, marginBottom: 20 }}
          onChange={e => this.props.handleChange(e)}
          defaultSelected={this.props.activity.communication_direction}
        >
          <RadioButton value="in" label={this.props.activity.commIn} />
          <RadioButton value="out" label={this.props.activity.commOut} />
        </RadioButtonGroup>
      </div>
    );
  };

  renderAdvancedInput = () => {
    if (this.props.sidebar === true && this.props.activity.open === false) {
      return null;
    }

    const labelColumnClassName =
      this.props.sidebar === true
        ? `col-xs-12 ${classes.sidebarLabel}`
        : 'col-xs-12 col-sm-4';
    const inputColumnClassName =
      this.props.sidebar === true ? 'col-xs-12' : 'col-xs-12 col-sm-8';
    const caretClassName =
      this.props.sidebar === true ? classes.caret : 'hidden';

    return (
      <div className={classes.advancedInput}>
        <div
          className={caretClassName}
          name="caret"
          onClick={() => {
            this.props.setState({ open: false });
          }}
        >
          <h5>
            {this.props.todayWidget ? 'Minimieren' : 'Neue Aktivität erstellen'}
          </h5>
          <InlineSVG
            src={caret}
            className="pointer"
            alt="Mehr Infos ein/ausblenden"
          />
        </div>
        <div className="row ">
          <div className={labelColumnClassName}>
            <label className="simpl-label">Bemerkungen</label>
          </div>
          <div className={inputColumnClassName}>
            <SimplWysiwyg
              content={this.props.activity.notes}
              onUpdate={content => {
                this.props.setState({ notes: content });
                // this.refreshSyncTimer();

                if (this.startSet === false) {
                  this.props.setState({
                    start_time: moment().format('YYYY-MM-DD'),
                    start_time_date_submit: moment().format('YYYY-MM-DD'),
                    start_time_time_submit: moment().format('HH:mm'),
                  });

                  this.startSet = true;
                }
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className={labelColumnClassName}>
            <label className="simpl-label">
              Art der{this.props.sidebar ? ' ' : <br />}Kommunikation
            </label>
          </div>
          <div className={inputColumnClassName}>
            <Select
              name="communication_type"
              value={this.props.activity.communication_type}
              options={communicationTypes}
              onChange={this.props.selectCommunicationType}
              placeholder="Kommunikationsart auswählen..."
              clearable={false}
            />
          </div>
          {this.renderCommunicationDirection()}
        </div>
        <div className="row">
          <div className={labelColumnClassName}>
            <label className="simpl-label">Teilnehmer</label>
          </div>
          <div className={inputColumnClassName}>
            <PeoplePicker
              type="all"
              name="person_ids"
              multi
              value={this.props.activity.personsRaw}
              onChange={e => this.props.personPicked(e)}
            />
          </div>
        </div>
        <div className={`row ${classes.buttonRow}`}>
          <div className="col-xs-6">
            <FlatButton
              label="Alle Felder anzeigen"
              primary
              onMouseDown={() => this.editActivityInModal()}
            />
          </div>
          <div className="col-xs-6">
            <RaisedButton
              label="Aktivität erstellen"
              primary
              disabled={this.props.activity.title.trim().length === 0}
              onMouseDown={() => this.props.save()}
            />
          </div>
        </div>
        <div className={`row`}>
          <div className="col-xs-12 text-center">{this.renderSync()}</div>
        </div>
      </div>
    );
  };

  renderSync = () => {
    let text = 'Noch nicht gespeichert.';

    if (this.props.activity.lastSync !== null) {
      text = `${this.props.activity.lastSync.fromNow()} gespeichert`;
    }

    return (
      <div
        className="sync"
        title="Einige Daten werden automatisch zwischengespeichert, um Datenverlust zu meiden. Davon ausgenommen: Teilnehmer, Aufgaben und beteiligte Unternehmen."
      >
        {text}
      </div>
    );
  };

  render() {
    const labelColumnClassName =
      this.props.sidebar === true ? 'hidden' : 'col-xs-12 col-sm-4';
    const inputColumnClassName =
      this.props.sidebar === true ? 'col-xs-12' : 'col-xs-12 col-sm-8';
    const cssWrapperSidebar =
      this.props.sidebar === true
        ? `${classes.sidebar}`
        : `${classes.dashboard}`;
    const cssWrapperToday =
      this.props.todayWidget === true ? classes.today : '';
    return (
      <div className={`${cssWrapperSidebar} ${cssWrapperToday}`}>
        <div className={`row ${classes.firstRow}`}>
          <div className={labelColumnClassName}>
            <label className="simpl-label">Thema</label>
          </div>
          <div className={inputColumnClassName}>
            <input
              name="title"
              required
              // className={this.activityError ? 'formatted error' : 'formatted'}
              className="formatted"
              onChange={e => this.props.handleChange(e)}
              onFocus={() => {
                this.props.setState({
                  open: true,
                });
              }}
              value={this.props.activity.title}
              placeholder={
                this.props.sidebar ? 'Neue Aktivität erstellen' : 'Thema'
              }
            />
          </div>
        </div>
        {this.renderAdvancedInput()}
      </div>
    );
  }
}
Embed.defaultProps = {
  sidebar: false,
  todayWidget: false,
};

Embed.propTypes = {
  activity: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setState: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
  closeActivityForm: PropTypes.func.isRequired,

  handleChange: PropTypes.func.isRequired,
  handleTimeChange: PropTypes.func.isRequired,
  personPicked: PropTypes.func.isRequired,
  companiesPicked: PropTypes.func.isRequired,
  selectCommunicationType: PropTypes.func.isRequired,

  sidebar: PropTypes.bool,
  todayWidget: PropTypes.bool,
};

export default Embed;



// WEBPACK FOOTER //
// ./src/components/FormActivity/Components/Embed.js